import Enum from './enum'

class ProposalFormat extends Enum
{
  constructor(value) {
    super(value);
  }
}

ProposalFormat.init({
  EMPTY: 'None',
  NUMBER: 'Number',
  CHOICE: 'List'
}, {
  EMPTY: 'proposal-format.empty',
  NUMBER: 'proposal-format.number',
  CHOICE: 'proposal-format.choice'
});

export default ProposalFormat;
